export enum ActionTypes {
    TOGGLE_MENU_OPEN = "TOGGLE_MENU_OPEN"
}
